import Post from '../api/post';
import * as mutation from '../mutations/post';

const state = {
  channel: {
    idx: 0,
    title: '',
    introduce: '',
    thumbnail: null,
    subscribe_cnt: 0,
    subscribes: false
  },
  post: {
    type: '', // 'feed', 'video', 'content'
    created_at: 0,
    updated_at: 0,
    idx: 0,
    title: '',
    contents: '',
    hashtag: [],
    menu_idx: 0,
    menus: null,
    nation_idx: 0,
    nations: null,
    image_list: null,
    thumbnail: null,
    view_cnt: 0,
    privacy: '',
    user: { idx: 0, name: '', profile_image: null },
    bookmarks: false,
    bookmark_cnt: 0,
    likes: false,
    like_cnt: 0,
    comments: [],
    comment_cnt: 0,
    // type 'video' only
    video_id: null,
    play_time: 0,
    published_at: null,
  },
  comments_max_page: 2,
  related_channels: [],
  similar_contents: [],
};

const getters = {
  channel: state => state.channel,
  post: state => state.post,
  relatedChannels: state => state.related_channels,
  similarContents: state => state.similar_contents,
  comments: state => state.post.comments,
};

const actions = {
  selectPost ({ commit }, idx) { // 포스트 하나 가져옴
    return Post.getPostIdx(idx).then(response => {
      commit(mutation.SELECT_POST, response);
    }).catch(err => {
      console.error(err);
    });
  },
  createPost (context, formData) { // 포스트 생성
    return Post.postPost(formData);
  },
  toggleLike (context, idx) { // 좋아요 & 좋아요 취소, 뮤테이션 별도 처리
    return Post.postPostIdxLike(idx);
  },
  toggleBookmark (context, idx) {
    return Post.postPostIdxBookmark(idx);
  },
  hidePost (context, idx) {
    return Post.postPostIdxHide(idx);
  },
  deletePost (context, idx) {
    return Post.deletePostIdx(idx);
  },
  createComment ({ commit }, { idx, content }) {
    return Post.postPostIdxComment(idx,content).then(response => {
      commit(mutation.CREATE_COMMENT, response.data);
    }).catch(err => {
      console.error(err);
    });
  },
  createRecomment ({ commit }, { postIdx, commentIdx, content }) {
    return Post.postPostIdxCommentIdxRecomment(postIdx, commentIdx, content).then(response => {
      commit(mutation.CREATE_RECOMMENT, response.data);
    }).catch(err => {
      console.error(err);
    });
  },
  toggleLikeComment ({ commit }, { postIdx, commentIdx }) {
    return Post.postPostIdxCommentIdxLike(postIdx, commentIdx).then(response => {
      commit(mutation.TOGGLE_LIKE_COMMENT, { postIdx, commentIdx, flag: response.data });
    }).catch(err => {
      console.error(err);
    });
  },
  toggleLikeRecomment ({ commit }, { postIdx, commentIdx, recommentIdx }) {
    return Post.postPostIdxRecommentIdxLike(postIdx, commentIdx, recommentIdx).then(response => {
      commit(mutation.TOGGLE_LIKE_RECOMMENT, { postIdx, commentIdx, recommentIdx, flag: response.data });
    }).catch(err => {
      console.error(err);
    });
  },
  reportComment (context, { postIdx, commentIdx }) {
    return Post.postPostIdxCommentIdxReport(postIdx, commentIdx);
  },
  reportRecomment (context, { postIdx, commentIdx, recommentIdx }) {
    return Post.postPostIdxRecommentIdxReport(postIdx, commentIdx, recommentIdx);
  },
  deleteComment ({ commit }, { postIdx, commentIdx }) {
    return Post.deletePostIdxCommentIdx(postIdx, commentIdx).then(response => {
      if (response.data) commit(mutation.DELETE_COMMENT, { postIdx, commentIdx });
    }).catch(err => {
      console.error(err);
    });
  },
  deleteRecomment ({ commit }, { postIdx, commentIdx, recommentIdx }) {
    return Post.deletePostIdxCommentIdxRecommentIdx(postIdx, commentIdx, recommentIdx).then(response => {
      if (response.data) commit(mutation.DELETE_RECOMMENT, { postIdx, commentIdx, recommentIdx });
    }).catch(err => {
      console.error(err);
    })
  },
  selectComments ({ commit }, { second, idx, page }) {
    if (page <= state.comments_max_page) {
      return Post.getPostIdxComment(second, idx, page).then(response => {
        commit(mutation.SELECT_COMMENTS, response);
      }).catch(err => {
        console.error(err);
      });
    }
  },
  selectRecomments ({ commit }, { second, postIdx, commentIdx, offset }) {
    return Post.getPostIdxCommentIdxRecomment(second, postIdx, commentIdx, offset).then(response => {
      commit(mutation.SELECT_RECOMMENTS, { commentIdx, response });
    }).catch(err => {
      console.error(err);
    });
  }
};

const mutations = {
  [mutation.SELECT_POST] (state, response) {
    state.channel = response.data.post.channels;
    state.post = response.data.post;
    // state.related_channels = response.data.related_channels;
    state.similar_contents = response.data.similar_contents;
  },
  [mutation.TOGGLE_SUBSCRIPTION] (state, { idx, flag }) { // 글 상세보기에서 구독
    if (state.related_channels.length) {
      let target = state.related_channels.find(el => {
        return el.idx === idx;
      });
      if (typeof target !== 'undefined') {
        target.subscribes = flag;
        flag ? target.subscribe_cnt++ : target.subscribe_cnt--;
      }
    }
    if (state.channel.idx === idx) {
      state.channel.subscribes = flag;
      flag ? state.channel.subscribe_cnt++ : state.channel.subscribe_cnt--;
    }
  },
  [mutation.TOGGLE_LIKE] (state, { idx, flag }) { // 상세보기 좋아요
    if (state.post.idx === idx && typeof flag === 'boolean') {
      state.post.likes = flag;
      flag ? state.post.like_cnt++ : state.post.like_cnt--;
    }
  },
  [mutation.TOGGLE_BOOKMARK] (state, { idx, flag }) { // 상세보기 북마크
    if (state.post.idx === idx) {
      state.post.bookmarks = flag;
      flag ? state.post.bookmark_cnt++ : state.post.bookmark_cnt--;
    }
  },
  [mutation.CREATE_COMMENT] (state, comment) {
    if (state.post.idx === comment.post_idx) {
      comment.recomments = [];
      comment.recomment_cnt = 0;
      state.post.comment_cnt++;
      state.post.comments.unshift(comment);
    }
  },
  [mutation.CREATE_RECOMMENT] (state, recomment) {
    if (state.post.idx === recomment.post_idx) {
      let target = state.post.comments.find(el => {
        return el.idx === recomment.comment_idx;
      });
      if (typeof target !== 'undefined') {
        state.post.comment_cnt++;
        target.recomment_cnt++;
        target.recomments.push(recomment);
      }
    }
  },
  [mutation.TOGGLE_LIKE_COMMENT] (state, { postIdx, commentIdx, flag }) {
    if (state.post.idx === postIdx) {
      let target = state.post.comments.find(el => {
        return el.idx === commentIdx;
      });
      if (typeof target !== 'undefined' && typeof flag === 'boolean') {
        target.likes = flag;
        flag ? target.like_cnt++ : target.like_cnt--;
      }
    }
  },
  [mutation.TOGGLE_LIKE_RECOMMENT] (state, { postIdx, commentIdx, recommentIdx, flag }) {
    if (state.post.idx === postIdx) {
      let parent = state.post.comments.find(el => {
        return el.idx === commentIdx;
      });
      if (typeof parent !== 'undefined') {
        let target = parent.recomments.find(el => {
          return el.idx === recommentIdx;
        });
        if (typeof target !== 'undefined' && typeof flag === 'boolean') {
          target.likes = flag;
          flag ? target.like_cnt++ : target.like_cnt--;
        }
      }
    }
  },
  [mutation.DELETE_COMMENT] (state, { postIdx, commentIdx }) {
    if (state.post.idx === postIdx) {
      let targetIndex = state.post.comments.findIndex(el => {
        return el.idx === commentIdx;
      });
      if (targetIndex > -1) {
        state.post.comments.splice(targetIndex, 1);
        state.post.comment_cnt--;
      }
    }
  },
  [mutation.DELETE_RECOMMENT] (state, { postIdx, commentIdx, recommentIdx }) {
    if (state.post.idx === postIdx) {
      let parent = state.post.comments.find(el => {
        return el.idx === commentIdx;
      });
      if (typeof parent !== 'undefined') {
        let targetIndex = parent.recomments.findIndex(el => {
          return el.idx === recommentIdx;
        });
        if (targetIndex > -1) {
          parent.recomments.splice(targetIndex, 1);
          parent.recomment_cnt--;
          state.post.comment_cnt--;
        }
      }
    }
  },
  [mutation.SELECT_COMMENTS] (state, response) {
    state.comments_max_page = response.max_page;
    if (response.req_page === 1) state.post.comments = response.data;
    else state.post.comments.push(...response.data);
  },
  [mutation.SELECT_RECOMMENTS] (state, { commentIdx, response }) {
    let target = state.post.comments.find(el => {
      return el.idx === commentIdx;
    });
    if (typeof target !== 'undefined') {
      target.recomments.push(...response.data);
    }
  }
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};
